/** Routes that use `RouteShell` (shared ambient + chrome). Caver `/game*` and `/dev*` stay outside. */
export function pathUsesBoggleRouteShell(pathname: string): boolean {
  if (pathname === '/game' || pathname.startsWith('/game/')) {
    return false
  }
  if (pathname === '/dev' || pathname.startsWith('/dev/')) {
    return false
  }
  return true
}
